import { render, staticRenderFns } from "./BlockTwoIconBlocks.vue?vue&type=template&id=02b4b301&"
import script from "./BlockTwoIconBlocks.vue?vue&type=script&lang=js&"
export * from "./BlockTwoIconBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports